import React, { FC } from 'react';
import cx from 'classnames';
import { MenuMyIcon } from '@move-ui/icons-asset-catalog';
import { useCurrentUser } from '../../utils/currentUser';
import Avatar from './Avatar';
import Badge from './Badge';
import iconStyles from './Icon.css';
import styles from './UserIcon.css';

type Props = {
  badge?: boolean;
  className?: string;
  isBranded?: boolean;
};

const UserIcon: FC<Props> = ({ badge, className, isBranded }): JSX.Element => {
  const { avatar, isLoggedIn, username } = useCurrentUser();

  if (!isLoggedIn) {
    return <MenuMyIcon className={cx(iconStyles.component, className)} />;
  }

  return (
    <div className={cx(styles.component, className)}>
      <Avatar
        avatar={avatar}
        className={styles.avatar}
        isBranded={isBranded}
        username={username}
      />
      {badge && <Badge className={styles.badge} />}
    </div>
  );
};

export default UserIcon;
